var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625 977 c-85 -34 -146 -97 -173 -176 -33 -94 -2 -221 69 -288 60 -56 115 -78 194 -78 85 1 144 25 200 81 131 134 96 360 -70 447 -48 25 -174 33 -220 14z m113 -108 c2 -12 -10 -20 -43 -28 -59 -15 -91 -47 -106 -105 -18 -73 -59 -56 -45 19 8 42 58 103 101 121 39 18 89 14 93 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 613 c-63 -61 -99 -104 -99 -118 0 -27 188 -215 216 -215 32 0 44 20 44 77 l0 53 74 0 c89 0 106 12 106 73 0 86 -2 87 -96 87 l-84 0 0 53 c0 55 -19 87 -50 87 -7 0 -57 -44 -111 -97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 222 c0 -141 1 -149 25 -185 32 -46 54 -47 83 -2 20 32 22 46 22 185 l0 150 -65 0 -65 0 0 -148z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLeft);
export default __webpack_public_path__ + "static/media/pin-left.bff04bd0.svg";
export { ForwardRef as ReactComponent };